import { configureStore } from '@reduxjs/toolkit';
import typeAReducer from '../components/typeA/typeASlice';

export const store = configureStore({
  reducer: {
    typeA: typeAReducer,
  },
});
